<div class="all">
    <mat-card class="m-auto padding12 card boxshadowgrey">
        <mat-card-title-group class="home-card" id="title">
            <mat-card-title>{{"HOME.WELCOME" | translate: {value: userName} }}</mat-card-title>
        </mat-card-title-group>
    
        <mat-card-content>
            <div class="home-card-content" id="content">
                <div class="home-nav">
                    <label>{{"HOME.INPUT" | translate}}</label>
                    <div class="field">
                        <form class="home-nav-content">
                            <mat-form-field>
                                <input type="text" matInput placeholder="{{'HOME.INPUT_HINT' | translate}}" [formControl]="myControl" [matAutocomplete]="auto" (keydown.enter)="setSearchValue($event)" >
                                <ng-container *ngIf="searching">
                                    <mat-progress-spinner matSuffix class="loadingSearch" mode="indeterminate" color="primary" diameter="25"></mat-progress-spinner></ng-container>
                                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                                <mat-option *ngFor="let option of machineConfigs" [value]="option.serialNumber" (click)="handleConnection(option)" [disabled]="option.imei === 'none'" >
                                    {{option.serialNumber}}</mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </form>
                        <div class="btn_connect">
                            <button mat-raised-button color="primary" (click)="startConnection()" [disabled]="!this.valid">{{"HOME.BTN_CONNECT" | translate }}</button>
                        </div>  
                    </div>
                        <ng-container *ngIf="this.connectionAttempt == true">
                            <div class="load">
                                {{"HOME.CONN_MESS" | translate}}
                                <div class="loading">
                                    <mat-progress-spinner mode="indeterminate" color="primary" diameter="35"></mat-progress-spinner>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="this.error == true">
                            <div class="error">
                                {{ this.error_mess | translate }}
                                <ng-container *ngIf="this.error_mess == 'ERROR.SENTRACK'">
                                    <mat-icon #tooltip="matTooltip" [matTooltip]="('ERROR.SENTRACK_TIP' | translate)" matTooltipPosition="below">info</mat-icon>
                                </ng-container>
                            </div>
                        </ng-container>
                </div>
                <div class="home-image-container" id="container">
                    <img class="home-image" src="../../assets/images/general/move-big-things-screen-1.png" height="100px" width="100px" alt="Move Big Things" />
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>